import PropTypes from "prop-types"
import * as React from "react"
import { useContext } from "react"
import { useDropdownToggle } from "@restart/ui/DropdownToggle"
import MetaDropdownContext from "@components/MetaDropdown/Group/MetaDropdownContext"
import useMergedRefs from "@restart/hooks/useMergedRefs"
import Triangle from "@images/triangle.svg"
import { classNames } from "@utils/classNames"

const MetaButtonForwardRef = React.forwardRef(
  ({ children, className, ...restProps }, ref) => {
    return (
      <button
        ref={ref}
        {...restProps}
        className={`
        inline-flex 
        items-center 
        py-2.5 px-4 desk:py-3 desk:px-5 
        border-0.5 border-dblue/20
        ${className}
      `}
        type="button"
      >
        {children}
        <span className="text-dblue/20 pl-1 mt-[-4px]">
          <img src={Triangle} alt="triangle" />
        </span>
      </button>
    )
  }
)

const propTypes = {
  id: PropTypes.string,
  split: PropTypes.bool,
  as: PropTypes.elementType,
}

const DropdownToggle = React.forwardRef(
  (
    { split, className, as: Component = MetaButtonForwardRef, ...props },
    ref
  ) => {
    const prefix = "dropdown-toggle"
    const dropdownContext = useContext(MetaDropdownContext)

    const [toggleProps] = useDropdownToggle()

    toggleProps.ref = useMergedRefs(toggleProps.ref, ref)

    return (
      <Component
        className={classNames(
          className,
          prefix,
          split && `${prefix}-split`,
          dropdownContext?.show && "show"
        )}
        {...toggleProps}
        {...props}
      />
    )
  }
)

DropdownToggle.displayName = "DropdownToggle"
DropdownToggle.propTypes = propTypes

export default DropdownToggle